<template>
    <div>
        <dx-grid
            url="smsdetails"
            baseUrl="https://petitioncampaigns.azurewebsites.net"
            :columns="columns"
            :title="title"
            :expandedOptions="{
                enabled: true,
                template: 'petition-sms-messages',
            }"
        ></dx-grid>
    </div>
</template>

<script>
import moment from "moment";
import { getDomain } from "../utils/helpers.js";

export default {
    data: () => ({
        title: "SMS Sessions",
        columns: [
            {
                field: "status",
                isIcon: true,
                template: "icon",
                alignment: "center",
                visible: true,
                allowFiltering: false,
                allowHeaderFiltering: false,
                allowHiding: false,
                allowSearch: false,
                cssClass: "width-25",
                headerFilter: {
                    allowSearch: false,
                    groupInterval: undefined,
                    height: undefined,
                    searchMode: "contains",
                    width: undefined,
                },
                icon: (value) => {
                    switch (value) {
                        case "Completed":
                            return "mdi-check-circle";
                        case "Aborted":
                            return "mdi-close-circle";
                        case "InProgress":
                            return "mdi-clock";
                        case "Error":
                            return "mdi-alert-circle";
                        default:
                            return "";
                    }
                },
                iconColor: (value) => {
                    switch (value) {
                        case "Completed":
                            return "success";
                        case "Aborted":
                            return "#aeb8bf";
                        case "Error":
                            return "#f35123";
                        default:
                            return "#fdb400";
                    }
                },
            },
            {
                label: "Name",
                field: "name",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Date",
                field: "date",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                sortOrder: "desc",
                sortIndex: 0,
                filterValues: [],
                filterValue: new Date(moment().subtract(1, "days")),
                selectedFilterOperation: ">",
                visible: true,
            },
            {
                label: "Session End",
                field: "sessionEnd",
                type: "date",
                format: "MM/dd/yyyy hh:mm:ss a",
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
                visible: true,
            },
            {
                label: "Caller ID",
                field: "callerId",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Email",
                field: "email",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Status",
                field: "status",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Address",
                field: "address",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
            {
                label: "Kids Count",
                field: "kidsCount",
                type: "number",
                visible: true,
                filterValues: [],
                filterValue: null,
                selectedFilterOperation: null,
            },
        ],
    }),
    created() {},
    methods: {},
};
</script>
<style></style>
